import * as PIXI from "pixi.js";
import Layers from "../../../../../../../../src/layers/Layers";
import { Coord, GridConfig } from "../../../../../../../../src/types/Interface";
import Line from "../../../../../../../../src/entities/Line/Line";
import { ArrowCap } from "../../../../../../../../src/types/Enum";
import getNumberConCoords from "./helpers/getNumberConCoords";
import { LineCoords } from "./types";
import getNumberText from "./helpers/getNumberText";


interface NumberCon extends PIXI.Container {
  numberText?: PIXI.Text
}

const defaultNumCoord = { x: -100, y: -100 };

export default class CoordinatePanelRenderer extends PIXI.Container {
  private Layers = Layers.getInstance();
  private pvtPoint: PIXI.Graphics = this.addChild(new PIXI.Graphics());
  private lines: Line[] = Array(4).fill(null).map(() => this.addLine());
  private numbers: NumberCon[] = Array(50).fill(null).map(() => this.drawNumberCon());
  constructor(private GridConfig: GridConfig) {
    super();
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Middle.addChild(this);
  private drawNumberCon() {
    const con: NumberCon = new PIXI.Container();
    const circle = new PIXI.Graphics()
      .circle(0, 0, 15)
      .fill(0xFFFFFF);
    con.numberText = new PIXI.Text();
    con.numberText.anchor.set(.5);
    con.addChild(circle, con.numberText);
    this.addChild(con);
    return con;
  }
  private addLine() {
    const line = new Line({ arrowCap: ArrowCap.End, width: 6, color: 0x000000 });
    line.parent.removeChild(line);
    return this.addChild(line);
  }
  drawCircle(originCoord: Coord) {
    this.pvtPoint
      .clear()
      .circle(originCoord.x, originCoord.y, 14)
      .stroke({ width: 3, color: 0xAAAAAA });
  }
  setNumbers(lineCoords: LineCoords) {
    const numberConCoords = getNumberConCoords(lineCoords, this.GridConfig.cellSize).filter(cArr => cArr.length > 0);
    numberConCoords.forEach((coords, coordsI) => coords.forEach((coord, coordI) => {
      const num = this.numbers[coordsI * coords.length + coordI];
      num.position.copyFrom(coord);
      num.numberText.text = getNumberText(this.GridConfig, lineCoords, coord);
    }
    ));
  }
  drawLines(lineCoords: LineCoords) {
    for (let index = 0; index < lineCoords.endCoords.length; index++) {
      const coord = lineCoords.endCoords[index];
      if (lineCoords.originCoord.x != coord.x || lineCoords.originCoord.y != coord.y) {
        this.lines[index].draw(lineCoords.originCoord, coord);
      }
    }
  }
  reset() {
    this.numbers.forEach(num => num.position.copyFrom(defaultNumCoord));
    this.lines.forEach(l => l.clear());
  }
}